"use client";

import { Toaster, toast, type ToasterProps } from "sonner";
import type { FC } from "react";
import styles from "@scss/custom-components/toaster.module.scss";

import { Loader } from "@mantine/core";

type ToastOptions = NonNullable<ToasterProps["toastOptions"]>;

// Global style defaults
const defaultOptions: ToastOptions = {
  unstyled: true,
  className: styles.toast,
  classNames: {
    success: styles.success,
    error: styles.error,
    info: styles.info,
    warning: styles.warning,
    loading: styles.loading,
    loader: styles.loaderWrapper,
    closeButton: styles.closeButton,
  },
  duration: 5000,
};

// Global icon defaults
const defaultIcons: NonNullable<ToasterProps["icons"]> = {
  success: <></>,
  error: <></>,
  info: <></>,
  warning: <></>,
  loading: <Loader size={15} className={styles.loader} />,
};

export const CustomToaster: FC<
  Omit<ToasterProps, "toastOptions" | "icons"> & {
    toastOptions?: ToastOptions;
    icons?: Partial<typeof defaultIcons>;
  }
> = ({ toastOptions, icons, ...rest }) => {
  const mergedOptions: ToastOptions = {
    ...defaultOptions,
    ...toastOptions,
    className: [defaultOptions.className, toastOptions?.className]
      .filter(Boolean)
      .join(" "),
    classNames: {
      ...defaultOptions.classNames,
      ...toastOptions?.classNames,
    },
  };

  const mergedIcons = {
    ...defaultIcons,
    ...icons,
  };

  return (
    <Toaster
      {...rest}
      toastOptions={mergedOptions}
      icons={mergedIcons}
      closeButton
    />
  );
};

export { toast };
